export const makePhaseWiseData = (logs) => {
     let sortAccordingM = {
        0: [],
    };
    for (let p of logs) {
        if (p.m === undefined || p.m === 0) {
            sortAccordingM["0"].push(p);
        } else {
            if (sortAccordingM[`${p.m}`] === undefined) {
                sortAccordingM[`${p.m}`] = [];
            }
            sortAccordingM[`${p.m}`].push(p);
        }
    } 
    return sortAccordingM
}